<template>
    <div class="shipping-cart-container">
        <p class="shipping-cart-title" style="margin-bottom: 20px">
            {{ $t("shoppingCart.title") }}
        </p>
        <!-- <div class="shipping-cart-tipbar">
      <a href="#" class="text-red">$1.00</a> Saved, Add
      <a href="#" class="text-red">1</a> more to get
      <a href="#" class="text-red">20%</a> OFF of the 3rd item
      <i class="el-icon-arrow-right"></i>
        </div>-->
        <el-scrollbar :style="{ height: height }">
            <div class="table-wrapper">
                <el-table
                    ref="shoppingTable"
                    :data="tableData"
                    :cell-style="cellStyle"
                    style="width: 100%"
                    header-cell-class-name="header-cell-class-name"
                    cell-class-name="cell-class-name"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        :label="`${$t('shoppingCart.tableName.item')}`"
                        width="550"
                    >
                        <template slot-scope="scope">
                            <div class="goods-info-wrapper">
                                <el-image
                                    :src="ossImg(scope.row.image, 100, 100)"
                                    :preview-src-list="[ossImg(scope.row.image, 800, 800)]"
                                    fit="contain"
                                    :lazy="true"
                                ></el-image>
                                <div class="info-wrapper">
                                    <div
                                        class="goods-name ellipsis-2"
                                        @click="toGoodsDetail(scope.row)"
                                    >
                                        {{ scope.row.goods_name }}
                                    </div>
                                    <div class="sku">
                                        <span>SKU:</span> {{ scope.row.sku }}
                                    </div>
                                    <div class="attr-value">
                                        {{ scope.row.attr_value }}
                                    </div>
                                    <template v-if="scope.row.array_mul == 1">
                                        <div
                                            class="goods-attribute"
                                            v-for="item of Object.entries(
                                                scope.row.custom_json
                                            )"
                                            :key="item[0]"
                                        >
                                            <p class="goods-attribute-label">
                                                {{ item[0] }}:
                                            </p>
                                            <template v-if="!isImlUrl(item[1])">
                                                <el-tooltip
                                                    v-if="item[1].length > 40"
                                                    :content="item[1]"
                                                    placement="top"
                                                >
                                                    <p
                                                        class="
                                                            goods-attribute-value
                                                            ellipsis
                                                        "
                                                        v-html="
                                                            item[1].replaceAll
                                                                ? item[1].split('\n').join('<br />')
                                                                : item[1]
                                                        "
                                                    ></p>
                                                </el-tooltip>
                                                <p
                                                    v-else
                                                    class="goods-attribute-value"
                                                    v-html="
                                                        item[1].replaceAll
                                                            ? item[1].split('\n').join('<br />')
                                                            : item[1]
                                                    "
                                                ></p>
                                            </template>
                                            <!-- Photo -->
                                            <div class="photo_set" v-else>
                                                <el-image
                                                    v-for="item of item[1].split(
                                                        ','
                                                    )"
                                                    :key="item"
                                                    :src="ossImg(item, 98, 98)"
                                                    fit="contain"
                                                    :lazy="true"
                                                ></el-image>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="scope.row.array_mul == 2">
                                        <div
                                            v-for="(item,index) in scope.row.custom_json"
                                            :key="index"
                                        >
                                            
                                                <div v-if="item.custom" style="padding:2px 10px;background-color:rgb(238, 242, 254);">Custom {{index+1}}</div>
                                                <div v-for="(v,k) in item.custom" :key="k"  style="padding: 5px 0 0 10px;">
                                                    <div v-if="isAnImage(v)">
                                                        {{k}} : <el-image
                                                            :src="ossImg(v, 80, 80)"
                                                            :preview-src-list="[ossImg(v, 800, 800)]"
                                                            fit="contain"
                                                            :lazy="true"
                                                        ></el-image>
                                                    </div>
                                                    <div v-else>{{k}} : {{v}}</div>
                                                </div>
                                            
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="`${$t('shoppingCart.tableName.price')}`"
                    >
                        <template slot-scope="scope"
                            >${{ scope.row.price }}</template
                        >
                    </el-table-column>
                    <el-table-column
                        :label="`${$t('shoppingCart.tableName.quantity')}`"
                        prop="quantity"
                        width="180"
                    >
                        <template slot-scope="scope">
                            <el-input-number
                                size="small"
                                v-model="scope.row.qty"
                                @change="qtyChange(scope.row)"
                                :min="1"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :label="`${$t('shoppingCart.tableName.subtotal')}`"
                    >
                        <template slot-scope="scope"
                            >${{
                                (scope.row.price * scope.row.qty).toFixed(2)
                            }}</template
                        >
                    </el-table-column>
                    <el-table-column
                        :label="`${$t('shoppingCart.tableName.remove')}`"
                    >
                        <template slot-scope="scope">
                            <el-popconfirm
                                :title="`${$t(
                                    'shoppingCart.tableName.removeTip'
                                )}`"
                                @confirm="deleteShopping(scope.row)"
                            >
                                <i slot="reference" class="el-icon-delete"></i>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                    <el-empty class="shopping-cart-empty" :image-size="120" slot="empty">
                        <img slot="image" src="@/assets/image/empty-data.svg" />
                        <!-- <span slot="description">{{
                            $i18n.locale == "zh" ? "暂无数据" : "No Data"
                        }}</span> -->
                        <el-button type="primary" size="mini" @click="$router.push('/goodsList')">Shop now</el-button>
                    </el-empty>
                </el-table>
            </div>
        </el-scrollbar>
        <div class="bottom-bar">
            <div class="subtotal">
                <p class="subtotal-label">
                    {{ $t("shoppingCart.checkout.subtotal") }}
                </p>
                <p class="subtotal-value">${{ subtotal.toFixed(2) }}</p>
            </div>
            <div class="total">
                <p class="total-label">
                    {{ $t("shoppingCart.checkout.total") }}
                </p>
                <p class="total-value">${{ orderAmount.toFixed(2) }}</p>
            </div>
            <div class="checkout-btn" @click="checkout">
                <el-button :loading="checkoutLoading">CHECKOUT</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import util from "@/utils/util.js";
export default {
    data() {
        return {
            checkoutLoading: false,
            tableData: [],
            checkedRows: [],
            orderInfo: {},
            subtotal: 0,
            discount: 0,
            orderAmount: 0,
            weight: 0,
            cartNum: 0,
            addedCartNum: 0,
            ossImg: util.ossImg
        };
    },
    methods: {
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 0) {
                return { verticalAlign: "middle" };
            }
            if (columnIndex == 2 || columnIndex == 4) {
                return { color: "#9b3c44" };
            }
        },
        shoppingCartList() {
            cmofferApi.shoppingCartList({}, "get").then((res) => {
                if (res.errcode == 0) {
                    this.tableData = res.data;
                    this.checkedRows = res.data;
                    if (this.tableData.length > 0) {
                        this.computedTableData();
                        this.$refs.shoppingTable.toggleAllSelection();
                    }
                }
            });
        },
        isAnImage(filePath){
            //获取最后一个.的位置
            var index= filePath.lastIndexOf(".");
            //获取后缀
            var ext = filePath.substr(index+1)
            return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1;
        },
        deleteShopping(item) {
            cmofferApi.shoppingCartList({}, "delete", item.id).then((res) => {
                if (res.errcode == 0) {
                    // this.shoppingCartList();
                    this.cartNum = this.cartNum - item.qty;
                    this.$store.commit("SETCARTNUM", this.cartNum);
                    window.location.reload(); // 重新刷新页面
                }
            });
        },
        // 商品数量计步器改变时
        qtyChange(val) {
            this.cartNum = 0;
            this.tableData.forEach((item) => {
                this.cartNum += +item.qty;
            });
            this.$store.commit("SETCARTNUM", this.cartNum);
            this.handleSelectionChange(this.checkedRows);
            this.shoppingCartChangeNum(val.id, val.qty);
        },
        computedTableData() {
            this.subtotal = 0;
            this.discount = 0;
            this.orderAmount = 0;
            this.weight = 0;
            this.cartNum = 0;
            this.addedCartNum = 0;
            this.tableData.forEach((item) => {
                this.subtotal += item.price * item.qty;
                this.discount += +item.discount;
                this.orderAmount = +this.subtotal + this.discount;
                this.weight += +item.weight;
                this.cartNum += +item.qty;
                this.addedCartNum += +item.qty;
            });
            this.$store.commit("SETCARTNUM", this.cartNum);
            this.$store.commit("SETADDEDCARTNUM", this.addedCartNum);
            this.orderInfo = {
                subtotal: this.subtotal,
                discount: this.discount,
                orderAmount: this.orderAmount,
                weight: this.weight,
            };
            this.$store.commit("SETORDERINFO", this.orderInfo);
        },
        checkout() {
            if (this.checkedRows.length == 0) {
                this.$message.warning("Please select an item");
                return;
            }
            sessionStorage.setItem(
                "ORDERDATA",
                JSON.stringify(this.checkedRows)
            );
            this.$store.commit("SETORDERDATA", this.checkedRows);
            this.$router.push({
                path: "shipping",
            });
        },
        handleSelectionChange(val) {
            this.checkedRows = val;
            this.subtotal = 0;
            this.discount = 0;
            this.orderAmount = 0;
            this.weight = 0;
            this.addedCartNum = 0;
            this.checkedRows.forEach((item) => {
                this.subtotal += item.price * item.qty;
                this.discount += +item.discount;
                this.orderAmount = +this.subtotal + this.discount;
                this.weight += +item.weight * item.qty;
                this.addedCartNum += +item.qty;
            });
            this.$store.commit("SETCARTNUM", this.cartNum);
            this.$store.commit("SETADDEDCARTNUM", this.addedCartNum);
            this.orderInfo = {
                subtotal: this.subtotal,
                discount: this.discount,
                orderAmount: this.orderAmount,
                weight: this.weight,
            };
            this.$store.commit("SETORDERINFO", this.orderInfo);
        },
        // 跳转到商品详情
        toGoodsDetail(item) {
            this.$router.push({
                path: `/goodsList/detail`,
                query: {
                    id: item.goods_id,
                },
            });
        },
        shoppingCartChangeNum(id, qty) {
            cmofferApi
                .shoppingCartChangeNum(
                    {
                        id,
                        qty,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        console.log(res);
                    }
                });
        },
    },
    computed: {
        height() {
            return `calc(100% - 200px)`;
        },
    },
    activated() {
        this.shoppingCartList();
    },
};
</script>

<style lang="scss" scoped>
.shipping-cart-container {
    padding: 15px 30px 30px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    text-align: left;
    .shipping-cart-title {
        font-size: 30px;
        font-weight: 600;
        letter-spacing: 1px;
    }
    .shipping-cart-tipbar {
        background-color: #f3f3f3;
        padding: 8px 20px;
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 26px;
        font-size: 13px;
        color: $color-333333;
        margin: 20px 0;
        a {
            font-weight: 800;
        }
        i {
            font-weight: 600;
            font-size: 12px;
            margin-left: 5px;
        }
    }
    .table-wrapper {
        ::v-deep .header-cell-class-name {
            background-color: transparent;
            font-size: 14px;
            color: $color-333333 !important;
        }
        ::v-deep .cell-class-name {
            vertical-align: top;
            font-size: 14px;
            .el-input-number {
                width: 120px;
            }
            .el-icon-delete {
                font-size: 20px;
                cursor: pointer;
                &:active {
                    opacity: 0.6;
                }
            }
        }

        ::v-deep .el-checkbox__input {
            &.is-indeterminate {
                .el-checkbox__inner {
                    &::before {
                        top: 7px;
                    }
                }
            }
            .el-checkbox__inner {
                width: 18px;
                height: 18px;
                &::after {
                    left: 6px;
                    top: 3px;
                }
            }
        }
        .goods-info-wrapper {
            display: flex;
            ::v-deep .el-image {
                width: 100px;
                height: 100px;
                flex-shrink: 0;
            }
            .info-wrapper {
                margin-left: 20px;
                font-size: 13px;
                flex: 1;
                .goods-name {
                    // width: 75%;
                    color: $color-333333;
                    margin-bottom: 5px;
                    font-weight: bold;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
                .sku,
                .attr-value {
                    & span:first-of-type {
                        color: $color-333333;
                        margin-right: 10px;
                    }
                    color: #000000;
                }
                .goods-attribute {
                    // margin-top: 5px;
                    font-size: 13px;
                    display: flex;
                    color: $color-333333;
                    .goods-attribute-label {
                        margin-right: 10px;
                        flex-shrink: 0;
                    }
                    .goods-attribute-value {
                        color: #000000;
                    }
                }
                .photo_set {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: flex-start;
                    .el-image {
                        margin-right: 2px;
                        margin-bottom: 2px;
                        box-sizing: border-box;
                        border: 1px solid #eee;
                    }
                }
            }
        }
        ::v-deep .shopping-cart-empty{
            .el-empty__bottom{
                margin-top: 0;
            }
        }
    }

    ::v-deep .el-scrollbar {
        .el-scrollbar__wrap {
            overflow: hidden;
            overflow-y: scroll;
        }
    }
    .bottom-bar {
        position: fixed;
        width: calc(100% - 201px);
        bottom: 0;
        right: 0;
        height: 85px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background-color: #f6f6f7;
        z-index: 100;
        padding: 0 40px 0 20px;
        box-sizing: border-box;
        .subtotal,
        .total {
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            font-weight: 600;
            .subtotal-label,
            .total-label {
                color: $color-808080;
                margin-right: 20px;
            }
            .subtotal-value,
            .total-value {
                color: #d53e3e;
            }
        }
        .total {
            font-size: 18px;
            margin: 0 30px 0 20px;
            .total-label {
                color: $color-333333;
                margin-right: 20px;
            }
        }
        .checkout-btn {
            width: 320px;
            z-index: 100;
            display: flex;
            align-items: center;
            justify-content: center;

            .el-button {
                width: 100%;
                height: 50px;
                // border-radius: 4px;
                background-color: $color-primary;
                text-align: center;
                cursor: pointer;
                color: #ffffff;
                button {
                    color: #fff;
                    font-size: 16px;
                    border: none;
                    outline: none;
                    background-color: transparent;
                }
                &:hover {
                    opacity: 0.95;
                }
                &:active {
                    opacity: 0.85;
                }
            }
        }
    }
    .text-red {
        color: #fd5a5a;
    }
}
</style>
